import AsyncButton from '../../../shared/Loading/AsyncButton';

const months = [
  { value: 1, label: 'Enero' },
  { value: 2, label: 'Febrero' },
  { value: 3, label: 'Marzo' },
  { value: 4, label: 'Abril' },
  { value: 5, label: 'Mayo' },
  { value: 6, label: 'Junio' },
  { value: 7, label: 'Julio' },
  { value: 8, label: 'Agosto' },
  { value: 9, label: 'Septiembre' },
  { value: 10, label: 'Octubre' },
  { value: 11, label: 'Noviembre' },
  { value: 12, label: 'Diciembre' },
];

const ScoreDateBaseSection = (props) => {
  if (!props.canEdit) return null;

  const value = props.scoreDateBase?.ConfigValue?.split('T')[0] ?? '';
  const maxDay = props.scoreDateMonth ? new Date(2024, Number(props.scoreDateMonth), 0).getDate() : 31;
  const days = Array.from({ length: maxDay }, (_, index) => index + 1);

  const handleMonthChange = (value) => {
    const nextMaxDay = value ? new Date(2024, Number(value), 0).getDate() : 31;
    props.setScoreDateMonth(value);
    if (Number(props.scoreDateDay) > nextMaxDay) {
      props.setScoreDateDay(String(nextMaxDay));
    }
  };

  return (
    <section className="bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden">
      <div className="flex flex-col gap-3 border-b border-gray-200 px-4 py-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h2 className="text-lg font-semibold text-gray-900">Fecha de reinicio de puntaje</h2>
          {value && <p className="text-sm text-gray-500">Fecha actual: {value}</p>}
        </div>
        <AsyncButton
          type="button"
          onClick={props.saveScoreDateBase}
          className="w-full sm:w-auto px-4 py-1.5 text-sm border border-transparent text-white rounded bg-personalized hover:bg-gray-100 hover:text-personalized hover:border-personalized"
        >
          Guardar
        </AsyncButton>
      </div>
      <div className="grid grid-cols-1 gap-3 p-4 sm:grid-cols-2">
        <label className="text-sm font-medium text-gray-700">
          Dia
          <select
            value={props.scoreDateDay}
            onChange={(e) => props.setScoreDateDay(e.target.value)}
            className="mt-1 w-full rounded border border-gray-300 px-3 py-2 text-sm disabled:bg-gray-100"
          >
            <option value="">Selecciona un dia</option>
            {days.map((day) => (
              <option key={day} value={String(day)}>{day}</option>
            ))}
          </select>
        </label>
        <label className="text-sm font-medium text-gray-700">
          Mes
          <select
            value={props.scoreDateMonth}
            onChange={(e) => handleMonthChange(e.target.value)}
            className="mt-1 w-full rounded border border-gray-300 px-3 py-2 text-sm disabled:bg-gray-100"
          >
            <option value="">Selecciona un mes</option>
            {months.map((month) => (
              <option key={month.value} value={String(month.value)}>{month.label}</option>
            ))}
          </select>
        </label>
      </div>
    </section>
  );
};

export default ScoreDateBaseSection;
